import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { checkAcessRights, formatIndianNumber } from "../../../_helper/helper";
import { EXCEL_EXPORT_ACCESS, PRINT_ACCESS } from "../../../_contstants/common";
import AlertBox from "../../../components/common/AlertBox";
import moment from "moment";
import { GetQuotationStatusReport } from "../services/reports.services";

const QuotationStatusReportView = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  // const navigate = useNavigate();
  const params = useParams();
  const isExcelExportAccess = checkAcessRights(
    "/quotationstatusreportform",
    EXCEL_EXPORT_ACCESS
  );
  const isPrintAccess = checkAcessRights(
    "/quotationstatusreportform",
    PRINT_ACCESS
  );

  const filterFromDate = params?.filterFromDate;
  const filterToDate = params?.filterToDate;
  const Destination = params?.Destination;
  const InquiryType = params?.InquiryType;
  const User = params?.User;
  // const Status = params?.Status;

  const loading = useAppSelector((state) => state.reports.loading);
  const QuotationStatusListForReport = useAppSelector(
    (state) => state.reports.QuotationStatusListForReport
  );

  const [uiLoading, setLoading] = React.useState<boolean>(true);

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (filterToDate && filterFromDate) {
      const payload = {
        FromDate: filterFromDate !== "0" ? filterFromDate : "",
        ToDate: filterToDate !== "0" ? filterToDate : "",
        Destination: Destination !== "0" ? Destination : "",
        InquiryType: InquiryType !== "0" ? InquiryType : "",
        // Status: Status !== "0" ? Status : "",
        Owner: User !== "0" ? User : "",
        CustomerName: "",
      };
      dispatch(GetQuotationStatusReport(payload));
    }
  }, []);

  const handleExportExcel = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(
      document.querySelector(".table-bordered")
    );
    XLSX.utils.book_append_sheet(wb, ws, "QuotationStatusReport");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, "quotationstatusreport.xlsx");
  };

  if (uiLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div
        className="report-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 10px",
        }}
      >
        <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
          Quotation Status Report{" "}
          <span style={{ fontSize: 15 }}>
            {QuotationStatusListForReport &&
              QuotationStatusListForReport.length > 0 &&
              `(
              ${
                filterFromDate !== "0"
                  ? moment(filterFromDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : ""
              }${filterFromDate !== "0" && filterToDate !== "0" ? " to " : ""}${
                filterToDate !== "0"
                  ? moment(filterToDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : " "
              }
              )`}
          </span>
        </Typography.h4>
        <div className="printbuttons">
          {isPrintAccess &&
            QuotationStatusListForReport &&
            QuotationStatusListForReport.length > 0 && (
              <Button
                style={{ marginRight: 5 }}
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={() => window.print()}
              >
                Print
              </Button>
            )}

          {isExcelExportAccess &&
            QuotationStatusListForReport &&
            QuotationStatusListForReport.length > 0 && (
              <Button
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={handleExportExcel}
              >
                Excel Export
              </Button>
            )}
        </div>
      </div>
      {QuotationStatusListForReport &&
      QuotationStatusListForReport.length > 0 ? (
        <div className="table-responsive" style={{ margin: "0 10px" }}>
          <table className="table table-bordered reportScreens lead-report">
            <thead>
              <tr>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  No
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Quotation ID
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Inquiry ID
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Customer Name
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Destination
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-end"
                >
                  Amount
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Created Date
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  User
                </th>
              </tr>
            </thead>
            <tbody>
              {QuotationStatusListForReport &&
                QuotationStatusListForReport.length > 0 &&
                QuotationStatusListForReport?.map(
                  (QuotationStatus: any, index: number) => (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      <td className="text-center">
                        {QuotationStatus?.QuotationNo || ""}
                      </td>
                      <td className="text-center">
                        {QuotationStatus?.Inquiryid || ""}
                      </td>
                      <td className="text-center">
                        {QuotationStatus?.Customername || ""}
                      </td>
                      <td className="text-center">
                        {QuotationStatus?.Destination || ""}
                      </td>
                      <td className="text-end">
                        {QuotationStatus?.Amount
                          ? formatIndianNumber(+QuotationStatus?.Amount)
                          : ""}
                      </td>
                      <td className="text-center">
                        {QuotationStatus?.CreatedDate
                          ? moment(
                              QuotationStatus?.CreatedDate,
                              "MM/DD/YYYY"
                            ).format("DD MMM YYYY")
                          : ""}
                      </td>
                      <td className="text-center">
                        {QuotationStatus?.Owner || ""}
                      </td>
                    </tr>
                  )
                )}
            </tbody>
          </table>
        </div>
      ) : (
        <AlertBox style={{ margin: "0 10px 10px" }} />
      )}
    </>
  );
};

export default QuotationStatusReportView;
